import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=d38d1c98"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"
import style0 from "./Button.vue?vue&type=style&index=0&id=d38d1c98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Spinner: require('/skade-pwa/components/ui/atom/Spinner.vue').default,Button: require('/skade-pwa/components/ui/atom/buttons/Button.vue').default})
